import React from "react";

import { ElementType, Suspense, lazy } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import ThemeProvider from "src/theme";

const Loadable = (Component: ElementType) => (props: any) => {
  return (
    <ThemeProvider>
      <Suspense>
        <Component {...props} />
      </Suspense>
    </ThemeProvider>
  );
};

function App() {
  return (
    <div className="app-container">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/email-completed" element={<EmailCompleted />} />
          <Route path="/fan-club" element={<FanClub />} />
          <Route path="/registration" element={<Registration />} />
          <Route path="/match-detail/:id" element={<MatchDetail />} />
          <Route path="/news-detail/:id" element={<NewsDetail />} />
          <Route path="/news-list" element={<NewsList />} />
          <Route path="/players-and-staff" element={<PlayersAndStaff />} />
          <Route path="/players-and-staff/player/:id" element={<PlayersAndStaffDetail />} />
          <Route path="/players-and-staff/staff/:id" element={<PlayersAndStaffDetail />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/selection" element={<Selection />} />
          <Route path="/team-info" element={<TeamInfo />} />
          <Route path="/schedule-results" element={<ScheduleAndResults />} />
          <Route path="/social-media-policy" element={<SocialMediaPolicy />} />
          <Route path="*" element={<NotFound />}></Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

const Contact = Loadable(lazy(() => import("./pages/contact")));
const EmailCompleted = Loadable(lazy(() => import("./pages/email-completed")));
const FanClub = Loadable(lazy(() => import("./pages/fan-club")));
const Registration = Loadable(lazy(() => import("./pages/registration")));
const Home = Loadable(lazy(() => import("./pages/home")));
const MatchDetail = Loadable(lazy(() => import("./pages/match-detail")));
const NewsDetail = Loadable(lazy(() => import("./pages/news-detail")));
const NewsList = Loadable(lazy(() => import("./pages/news-list")));
const NotFound = Loadable(lazy(() => import("./pages/404")));
const PlayersAndStaff = Loadable(lazy(() => import("./pages/players-and-staff")));
const PlayersAndStaffDetail = Loadable(lazy(() => import("./pages/players-and-staff-detail")));
const PrivacyPolicy = Loadable(lazy(() => import("./pages/privacy-policy")));
const Selection = Loadable(lazy(() => import("./pages/selection")));
const TeamInfo = Loadable(lazy(() => import("./pages/team-info")));
const ScheduleAndResults = Loadable(lazy(() => import("./pages/schedule-results")));
const SocialMediaPolicy = Loadable(lazy(() => import("./pages/social-media-policy")));

export default App;
